<template>
  <div ref="popover" class="popover popover--default" role="tooltip">
    <div class="popover__body text-small">
      <button @click.stop="hide" class="popover__close-btn btn btn--bare" :title="labels.close">
        <Icon class="icon--small" iconId="cross" />
      </button>

      <template v-if="this.loaded">
        <h6 class="mrgt0">{{ title }}</h6>
        <div class="wysiwyg" v-html="definition"></div>

        <p v-if="reference.href" class="text-right mrgb0 mrgt--">
          <a :href="reference.href" class="link--alt text-bold">
            {{ labels.glossary }}
            <Icon class="icon--small" iconId="chevron-right" />
          </a>
        </p>
      </template>

      <div v-else class="text-center">
        <Loader></Loader>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  import Icon from 'vue-pages/components/Icon';
  import Loader from 'vue-pages/components/Loader';
  import api from 'components/Api';

  export default Vue.extend({
    components: {
      Icon,
      Loader,
    },

    data() {
      return {
        displayed: false,
        loaded: false,
        reference: null,
        id: null,
        title: '',
        definition: '',
      }
    },

    mounted() {
      if (!this.loaded) {
        this.load();
      }

      this._popover = new Styleguide.Popover(this.$refs.popover, {
        placement: 'top',
        reference: this.reference,
        onShow: () => { this.displayed = true },
        onHide: () => { this.displayed = false },
      });
      this._popover.show();
    },

    updated() {
      this._popover.update();
    },

    methods: {
      load() {
        api.get(`/api/glossary/${this.id}`)
          .then(data => {
            this.loaded = true;
            this.title = data.name;
            this.definition = data.content;
          });
      },

      show() {
        if (!this.displayed) {
          this._popover.show();
        }
      },

      hide() {
        if (this.displayed) {
          this._popover.hide();
        }
      }
    },
  })
</script>
